import { Observable } from '../types';

enum ConsentCategory {
  FUNCTIONAL = 'FUNCTIONAL',
  PERFORMANCE = 'PERFORMANCE',
  SOCIAL_MEDIA = 'SOCIAL_MEDIA',
  STRICTLY_NECESSARY = 'STRICTLY_NECESSARY',
  TARGETING = 'TARGETING',
}

enum ConsentEvent {
  CONSENT_STATE_CHANGE = 'CONSENT_STATE_CHANGE',
}

interface ConsentMediatorType extends Observable<ConsentEvent, ConsentState> {
  initialize: () => void;
  getConsentState: () => ConsentState;
}

interface ConsentState {
  [ConsentCategory.FUNCTIONAL]: ConsentType;
  [ConsentCategory.PERFORMANCE]: ConsentType;
  [ConsentCategory.SOCIAL_MEDIA]: ConsentType;
  [ConsentCategory.STRICTLY_NECESSARY]: ConsentType;
  [ConsentCategory.TARGETING]: ConsentType;
}

interface ShopConfig {
  shopID: string;
  environment: Environment;
  oneTrustID: string;
  defaultScriptStatus: ConsentType;
  rudderStackId: string;
}

type ConsentStateObserverFunction = (consentState: ConsentState) => void;

enum ConsentType {
  UNKNOWN = 'UNKNOWN',
  CONSENTED = 'CONSENTED',
  DENIED = 'DENIED',
}

enum Environment {
  DEVELOPMENT = 'development',
  STAGING = 'staging',
  PRODUCTION = 'production',
}

export {
  ConsentCategory,
  ConsentEvent,
  ConsentMediatorType,
  ConsentState,
  ConsentStateObserverFunction,
  ConsentType,
  ShopConfig,
  Environment,
};
